import React, { Component } from "react";
import CustomLink from "@/bit/components/next13.components.custom-link";
import Text from "@/bit/components/next13.components.text";

class MenuGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupOpened: false,
    };
  }

  handleClick = () => {
    this.setState({
      groupOpened: !this.state.groupOpened,
    });
  };

  render() {
    const { item } = this.props;
    const items = item["sections"];
    let i = 0;
    if (!item) {
      return null;
    }
    return (
      <>
        <div className="menu-group">
          <div className="menu-group-header" onClick={this.handleClick}>
            <div className="text-gap">
              <Text
                text={item.text}
                fontType="font-regular"
                size="caption01"
                color="grey5"
                display="block"
              />
            </div>
            <div className="icon-gap">
              {!this.state.groupOpened && (
                 <IconGlyph color="grey5" id="cheuron-down-m" width={12} />
                 )}
              {this.state.groupOpened && (
                 <IconGlyph color="grey5" id="cheuron-up-m" width={12} />
              )}
            </div>
          </div>
          {this.state.groupOpened && (
            <div className="sections">
              {items.map((subitem) => {
                const link = subitem.link ? item.link : "#";
                const text = subitem.text;
                return (
                  <div key={`item-${i++}`} className="menu-item">
                    <CustomLink
                      href={link}
                      title=""
                      ariaLabel=""
                      taggingInfo={{
                        componentName: "header",
                        componentContent: "menu",
                        componentVariation: "all",
                        componentPerso: "",
                        componentProduct: "",
                      }}
                    >
                      <Text
                        text={text}
                        fontType="font-regular"
                        size="caption01"
                        color="grey5"
                        display="block"
                      />
                    </CustomLink>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </>
    );
  }
}

export default MenuGroup;
